export default {
  theEmailIsNecessaryToSendYouTheTicketOrInvoices:
    "L'e-mail est nécessaire pour vous envoyer les billets ou les factures.",
  enterTheAmountInKilograms: "Entrez le montant en kilogrammes",
  pleaseScanAValidQRCode: "Veuillez scanner un code QR valide.",
  doYouWantToReceiveYourTicketInvoiceInYour:
    "Voulez-vous recevoir votre billet / facture dans votre",
  whatDoYouWantToPay: "Que voulez-vous payer ?",
  noProductsLeftToPay: "Plus aucun produit à payer",
  totalSelected: "Total sélectionné :",
  error: "Erreur !",
  discard: "Jeter",
  thereIsNoOrderForTheTable: "Il n'y a pas de commande pour la table",
  tableOrder: "Ordre des tableaux",
  invitation: "INVITATION",
  splitAccount: "compte fractionné",
  byProducts: "par produits",
  cookingMeat: "CUISSON DE LA VIANDE",
  chooseYourDrink: "CHOISISSEZ VOTRE BOISSON",
  chooseYourDishes: "Choisissez vos plats",
  selectTheQRCodeOfTheTable: "Sélectionnez le QR code de votre table",
  oopsSelectYourTable: "Oups, sélectionnez votre table",
  selectYourTable: "Sélectionnez votre tableau",
  wellCooked: "Bien cuit",
  toThePoint: "Jusqu'au point",
  underCooked: "Pas assez cuit",
  pleaseDecreaseTheQuantityOfProducts:
    "Veuillez diminuer la quantité de produits",
  divide: "Diviser",
  among: "Parmi",
  amountToPay: "Montant à payer",
  amount: "Montant",
  allTheProducts: "Tous les produits",
  pleaseEnterValidAmount:
    "Veuillez saisir un montant valide supérieur à 0,50 € ou inférieur à"
};
